import React from 'react'

function Subheading({children}) {
  return (
    <p><strong>{children}</strong></p>
  )
}

export default Subheading